module.exports = __webpack_public_path__ + "static/media/mycme-logo_registered.f3e66a7b.svg";